import { commonConstants } from "../constants";

export const allSensors = (state) => {
  return (
    (state && state.masterData && state.masterData.metadata && state.masterData.metadata.sensors) ||
    []
  );
};

export const allSensorParameters = (state) => {
  return (
    (state &&
      state.masterData &&
      state.masterData.metadata &&
      state.masterData.metadata.sensor_parameters) ||
    []
  );
};

export const allGrains = (state) => {
  return (
    (state && state.masterData && state.masterData.metadata && state.masterData.metadata.grain) ||
    []
  );
};

export const isPhoneAlertAllowed = (state) => {
  const value =
    state &&
    state.masterData &&
    state.masterData.metadata &&
    state.masterData.metadata.meta &&
    state.masterData.metadata.meta.phone_alert_allowed;

  if (typeof value === "string") {
    return ["1", "yes", "true"].includes(value.toLowerCase());
  }

  return value === true || value === 1;
};

export const refreshPageInterval = (state) => {
  return (
    (state &&
      state.authentication &&
      state.authentication.user &&
      state.authentication.user.dashboard_refresh_interval) ||
    commonConstants.grain.MIN30
  );
};

export const getSensorParameters = (allSensorParameters, parameter_id) => {
  const sensorParameter = allSensorParameters.find(
    (obj) => parseInt(obj.parameter_id, 10) === parseInt(parameter_id, 10)
  );
  return sensorParameter ? sensorParameter : null;
};

export const getSensor = (allSensors, sensor_id) => {
  const sensor = allSensors.find((obj) => parseInt(obj.sensor_id, 10) === parseInt(sensor_id, 10));
  return sensor ? sensor : null;
};

export const getFirstSensorId = (data, index = 0) => {
  return (data && data[index] && data[index].sensor_id) || "";
};

export const getFirstSensorPrameterId = (data, index = 0) => {
  return (data && data[index] && data[index].parameter_id) || "";
};

export const getFirstlGrainId = (data, index = 0) => {
  return (data && data[index] && data[index].id) || "";
};

export const allHours = (is_half_hour = false) => {
  let hours = [];
  for (let i = 0; i <= 23; i++) {
    if (i < 10) {
      i = "0" + i;
    }
    hours.push({ id: i + ":00:00", label: i + ":00" });
    if (is_half_hour) {
      hours.push({ id: i + ":30:00", label: i + ":30" });
    }
  }
  return hours;
};
